import styled from "styled-components";
 
export default styled.div`
  /* display: flex;
  justify-content: center;
  align-items: center; */
  height: auto;
  width: 100%;
  ${'' /* background-color: #FF7043; */}
  color: #fff;
  margin: 15px ;
  overflow:"visible"
  font-size: 1em;
  padding:10px;
`;
